// Utility to clear failed consultation records from sync queue
import { clearFailedConsultations } from '../sync-tracker';

/**
 * Clear all failed consultation records from the sync queue
 * This fixes the duplicate key constraint violations
 */
export function clearFailedConsultationRecords() {
  try {
    const clearedCount = clearFailedConsultations();
    console.log(`✅ Cleared ${clearedCount} failed consultation records from sync queue`);
    return clearedCount;
  } catch (error) {
    console.error('❌ Error clearing failed consultation records:', error);
    return 0;
  }
}

// Make it available globally for easy access
if (typeof window !== 'undefined') {
  (window as any).clearFailedConsultations = clearFailedConsultationRecords;
}
